import {Ref, forwardRef, useEffect, useImperativeHandle, useReducer, useRef, useState} from 'react';
import {Cascader, FormInstance, Input, Spin, message} from 'antd';
import {get, cloneDeep, isEmpty, isArray} from 'lodash-es';
import {SDrawer, SGeneralForms} from 'shj-components';
import {getAuth, getUser} from 'shj-utils';
import {dealSearch, getParentId} from '@/utils/common';
// import { CheckThePhoneSNM } from '@/components/CheckThePhone';
// import { getBusinessLinesByDeptCode, getChildrenDicts, getEnums } from '@/services';
// import { addClue, findBizState, getCustomerDetails, getCustomerSource, updateSNMClue } from '@/services/publicInformation';
// import { getAllCompany, getRealEstateList } from '@/services/custom';
// import { getBranchComponyList } from '@/services/orderManageTmall';
import dayjs from 'dayjs';
import CheckThePhone from "@/components/CheckThePhone";
// import { findByPhoneExt } from '@/services/member';

export const ModalAddOrEditDom: React.FC<any> = forwardRef(({fn, dataFinishFn, record, onClose, ...rest}, ref) => {
  const isEdit = !!record?.id;
  const formRef = useRef<Ref<any> & { onFormRef: () => FormInstance }>(null);
  const userInfo = getUser() || {};
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);//需求状态
  const [infoObj, setInfoObj] = useState<any>({}); // 存放详情的结果集
  const [houseStatusCode, setHouseStatusCode] = useState<any>('');//房屋状态初始值
  const [giveHouseDate, setGiveHouseDate] = useState<any>('');//交房日期初始值
  const [sourceChannelList, setSourceChannelList] = useState<any>('');//客户来源
  const [phone, setPhone] = useState<any>('');//客户来源
  console.log('isEdit', isEdit);
  useEffect(() => {
    formRef.current?.onFormRef()?.resetFields();
    // initList();
    if (isEdit) {
      // findBizState({ params: { id: record.id } }).then((resp: any) => {
      //     setStatus(resp);
      // });
    }
  }, [record]);

  const btnStatus = (otherStatus: boolean) => {
    // A0060岗位和【超级管理员】角色拥有特殊权限，可以在任何条件下编辑所有字段。
    if (!!getAuth()?.editClueBtn) {
      return false;
    }
    // 该线索关联的需求中只要有一个需求的状态是退单、退定、完工、在建的，则线索上所有字段都不允许编辑。
    if (['chargeback', 'withdrawEarnest', 'underConstruction', 'completion'].indexOf(status ? status : '') != -1) {
      return true;
    }
    return otherStatus;
  }
  // 是否签单
  const salesFlag = () => {
    if (['firstSigning', 'secondSigning', 'manySigning', 'earnestSigning'].indexOf(status ? status : '') != -1) {
      return true;
    }
    return false;
  };

  const hasRemark = (key, valueKey) => infoObj[key]?.includes(valueKey)

  const initList = async () => {
    setLoading(true);
    return new Promise((resolve, reject) => {
      try {
        const companyCodeAuth = get(userInfo, 'extend.companyCode', '');
        const deptCode = get(userInfo, 'extend.deptCode', '');
        let list1 = [
          'customerLevel',//级别
          'customerProfession',//职业
          'customerAgeRange',//年龄
          'bizOpPropertyType',//房屋属性
          'houseType',//户型
          'housePropertyType',//房屋类型
          'signBillIntent',//签单意向
          'AreaInterval',//建筑面积区间
          'houseDecorateStyle',//装修风格
          'budget',//装修预算
          'residencePurpose',//居住目的
          'permanentResidents',//常住人口
          'PainPoint',//痛点
          'Itchy',//痒点
          'ObstaclePoint',//爆破点
          'BlastingPoint',//障碍点
          'productionType',//钉钉产品
          'functionNeed',//功能需求
        ];
        Promise.all([
          // getChildrenDicts(list1),
          // getAllCompany(),
          // getEnums('clue', 'com.shj.saas.crm.domain.bizop.enums.HouseStatusEnum'),
          // getEnums('clue', 'com.shj.saas.clue.domain.enums.ArmyAffiliation'),
          // getBusinessLinesByDeptCode({ params: { deptCode } }),
          // getBranchComponyList(),
          // getCustomerSource({ params: { enable: isEdit ? null : true } }),
          // getRealEstateList({ companyCode: companyCodeAuth }),
          // isEdit && getCustomerDetails(record.id, false),
        ]).then(async (res) => {
          const obj: any = {
            companyList: rest?.isCall ? (res[5] || []) : (res[1] || []),
            houseStatusList: res[2] || [],
            armyAffiliationList: res[3] || [],
            brandList: res[4] || [],
            buildList: res[7] || []
          }
          isArray(res[0]) && res[0].map((item: any) => {
            list1.map((items: any) => {
              if (items == item.key) {
                obj[`${items}List`] = item.children || [];
              }
            });
          });
          setSourceChannelList(res[6] || [])

          if (isEdit) {
            let respObj = res[8] || {};
            const {companyCode} = respObj;
            if (companyCode != companyCodeAuth) {
              // const buildList = await getRealEstateList({ companyCode });
              formRef.current?.onFormRef()?.resetFields(['buildingId']);
              // formRef.current?.updateState({ buildList });
              obj.buildList = [] //buildList
            }
            const sourceChannelArray = getParentId((res[6] || []), respObj.channelId);
            let _sourceChannel;
            if (isArray(sourceChannelArray)) {
              _sourceChannel = sourceChannelArray.reverse().map((item: string | number) => {
                return item
              });
            } else {
              _sourceChannel = [respObj.channelId];
            }
            respObj = dealSearch(respObj)
            const _obj = {
              ...respObj,
              ...respObj.customer,
              ...respObj.customer?.contactInfo,
              birthday: respObj.customer?.birthday && dayjs(respObj.customer?.birthday),
              wechatNo: respObj.customer?.contactInfo?.wecat,
              ...(respObj.buildingId && {buildingId: respObj.buildingId}),
              ...(respObj.painPoint && {painPoint: respObj.painPoint.split('-')}),
              ...(respObj.itchPoint && {itchPoint: respObj.itchPoint.split('-')}),
              ...(respObj.breakPoint && {breakPoint: respObj.breakPoint.split('-')}),
              ...(respObj.blockPoint && {blockPoint: respObj.blockPoint.split('-')}),
              ...(respObj.appointmentRoomTime && {appointmentRoomTime: dayjs(respObj.appointmentRoomTime)}),
              ...(respObj.giveHouseDate && {giveHouseDate: dayjs(respObj.giveHouseDate)}),
              ...(respObj.expectRenovationDate && {expectRenovationDate: dayjs(respObj.expectRenovationDate)}),
              ...(respObj.estimatedRenovationTime && {
                estimatedRenovationTime: dayjs(respObj.estimatedRenovationTime),
              }),
              ...(respObj.lookingForwardToStayingTime && {
                lookingForwardToStayingTime: dayjs(respObj.lookingForwardToStayingTime),
              }),
              channelId: _sourceChannel,
              productIntention: respObj.productIntention !== 'all' ? respObj.productIntention : null,
            };
            // 户型:两室一厅（houseType2B1P）。 字典已经停用
            if (_obj.houseTypeCode && Array.isArray(obj['houseTypeList']) && obj['houseTypeList'].filter(item => item.key == _obj.houseTypeCode).length != 1) {
              obj['houseTypeList'] = obj['houseTypeList'].concat([{
                key: _obj.houseTypeCode,
                name: _obj.houseType,
                disabled: true
              }])
            }
            // 房屋属性:成品房 字典已经停用
            if (_obj.houseNatureCode && Array.isArray(obj['bizOpPropertyTypeList']) && obj['bizOpPropertyTypeList'].filter(item => item.key == _obj.houseNatureCode).length != 1) {
              obj['bizOpPropertyTypeList'] = obj['bizOpPropertyTypeList'].concat([{
                key: _obj.houseNatureCode,
                name: _obj.houseNature,
                disabled: true
              }])
            }
            setHouseStatusCode(_obj.houseStatusCode);
            setGiveHouseDate(_obj.giveHouseDate);
            setInfoObj(_obj);
            setPhone(_obj?.phone)
            formRef.current?.onFormRef()?.setFieldsValue(_obj);
          } else {
            formRef.current?.onFormRef()?.setFieldsValue({companyCode: companyCodeAuth});
          }
          console.log('obj', obj)
          resolve({...obj, gender: [{label: '男', value: '男'}, {label: '女', value: '女'}]});
          setLoading(false);
          dataFinishFn && dataFinishFn();
        });
      } catch (e) {
        setLoading(false);
        dataFinishFn && dataFinishFn();
        reject({success: false});
      }
    })
  };

  // 提交
  const onFinish = (values) => {
    return new Promise((resolve, reject) => {
      if (loading) {
        reject({});
        return false
      }
      ;
      setLoading(true);
      formRef.current?.onFormRef()?.validateFields().then(res => {
        try {
          let newValues = cloneDeep(formRef.current?.onFormRef()?.getFieldsValue());
          newValues.sourceFlag = 'pc';
          let arr = [
            'birthday',
            'giveHouseDate',
            'expectRenovationDate',
            'estimatedRenovationTime',
            'lookingForwardToStayingTime',
          ];
          arr.map((item) => {
            if (newValues[item]) {
              newValues[item] = dayjs(newValues[item]).format('YYYY-MM-DD');
            } else {
              delete newValues[item];
            }
          });
          let arr1 = ['estimatedRenovationTime', 'lookingForwardToStayingTime'];
          arr1.map((item) => {
            if (newValues[item]) {
              newValues[item] = dayjs(newValues[item]).format('YYYY-MM-DD 00:00:00');
            } else {
              delete newValues[item];
            }
          });
          if (newValues.appointmentRoomTime) {
            newValues.appointmentRoomTime = dayjs(newValues.appointmentRoomTime).format('YYYY-MM-DD HH:mm:ss');
          } else {
            delete newValues.appointmentRoomTime;
          }
          // 判断手机号是否更改，没更改不传后端
          if (phone === newValues.phone) {
            delete newValues.phone
          }
          const {channelId} = newValues;
          if (channelId) {
            newValues.channelId = channelId[channelId.length - 1];
          }
          // if (newValues.houseStatusCode === 'FUTURE_HOUSE' && !newValues.giveHouseDate) {
          //     message.warning('房屋状态为期房时，需要选择交房日期');
          //     setLoading(false);
          //     reject({})
          //     return;
          // }
          if (newValues.painPoint) {
            newValues.painPoint = newValues.painPoint.join('-') || '';
          }
          if (newValues.itchPoint) {
            newValues.itchPoint = newValues.itchPoint.join('-') || '';
          }
          if (newValues.breakPoint) {
            newValues.breakPoint = newValues.breakPoint.join('-') || '';
          }
          if (newValues.blockPoint) {
            newValues.blockPoint = newValues.blockPoint.join('-') || '';
          }

          if (!!houseStatusCode && !!giveHouseDate) {
            delete newValues.houseStatusCode;
            delete newValues.giveHouseDate;
          }
          const dataReq = {
            ...newValues,
            ...(infoObj?.houseId && {houseId: infoObj?.houseId}),
            ...(infoObj?.contactId && {contactId: infoObj?.contactId}),
            ...(infoObj?.overallDecoId && {overallDecoId: infoObj?.overallDecoId}),
            buildingEmphasisFlag: infoObj?.buildingEmphasisFlag == true ? 1 : 0,
            ...(isEdit && {id: record.id}),
            customerId: infoObj?.customerId,
            clueSource: isEdit ? null : 'MANUAL',
          }
          let requestPost = isEdit //? updateSNMClue : addClue;
          // requestPost({
          //     data: dataReq,
          // }).then((resp) => {
          //     message.success(`${record.id ? '修改' : '创建'}线索成功`);
          //     fn && fn();
          //     setLoading(false);
          //     resolve({ msg: '提交成功' });
          // }).catch((err) => {
          //     setLoading(false);
          //     reject({ errMsg: err });
          // });
        } catch (err) {
          reject(err);
        }

      }).catch(err => {
        reject(err);
        setLoading(false);
      })
    })
  };

    useImperativeHandle(
        ref,
        () => ({
            formRef: formRef.current,
            onFinish
        }),
        [formRef, onFinish],
    );
    return <Spin spinning={loading}>
        <SGeneralForms
            formConfig={{
                onValuesChange: (val) => {
                    setInfoObj({
                        ...infoObj,
                        ...val,
                    });
                },
            }}
            isHideGobackBtn={true}
            httpOptionsFn={initList}
            layout="vertical"
            isFooterBtn={false}
            footerAlign="right"
            ref={formRef}
            onFinish={onFinish}
            configs={[
                {
                    title: '客户信息',
                    formItem: [
                        {
                            name: 'phone',
                            label: '客户电话',
                            required: true,
                            spanCol: 12,
                            children: <Input
                                disabled={getAuth['customerManageBtnPhone']}
                                onBlur={(e) => {
                                    let phone = e.target.value;
                                    // let companyCode = formRef.current?.onFormRef()?.getFieldValue('companyCode');
                                    // let buildingId = formRef.current?.onFormRef()?.getFieldValue('buildingId');
                                    // if (companyCode && buildingId) {
                                    //     getIsHaveBiz({ phone, companyCode, buildingId });
                                    // }
                                    if (!phone) return;
                                    if (!/^1\d{10}$/.test(phone)) {
                                        message.info('输入正确的手机号');
                                        formRef.current?.onFormRef()?.resetFields(['phone']);
                                        return;
                                    }
                                    // findByPhoneExt(phone).then((res) => {
                                    //     const obj = res;
                                    //     if (obj) {
                                    //         formRef.current?.onFormRef()?.setFieldsValue({
                                    //             ...obj,
                                    //             // ...(obj.contactInfo && { ...obj.contactInfo }),
                                    //             ...(obj.birthday && { birthday: dayjs(obj.birthday) }),
                                    //             aliww: obj.contactInfo?.aliww,
                                    //             email: obj.contactInfo?.email,
                                    //             qq: obj.contactInfo?.qq,
                                    //         });
                                    //     }
                                    // });
                                }}
                                placeholder="请输入"
                                style={{ width: '100%' }}
                                suffix={
                                    isEdit ?
                                        <CheckThePhone id={record.id} type='clue' auth='crmPhoneAccessBtn' fn={(val) => {
                                            if (val) {
                                                formRef.current?.onFormRef()?.setFieldsValue({ phone: val });
                                            } else if (isEmpty(val)) {
                                                formRef.current?.onFormRef()?.setFieldsValue({ phone: infoObj?.phone });
                                            }
                                        }} />
                                        : null
                                }
                            />
                        },
                        {
                            name: 'name',
                            label: '姓名',
                            required: true,
                            spanCol: 12,
                            comConfig: {
                                disabled: btnStatus(salesFlag()),
                            }
                        },
                        {
                            name: 'gender',
                            label: '性别',
                            spanCol: 12,
                            type: "radio",
                            data: "gender",
                            comConfig: {
                                disabled: btnStatus(false),
                            }
                        },
                        {
                            name: 'birthday',
                            label: '生日',
                            spanCol: 12,
                            type: "date",
                            comConfig: {
                                disabled: btnStatus(false),
                            },
                        },
                        {
                            name: 'age',
                            label: '年龄',
                            spanCol: 12,
                            type: 'select',
                            data: 'customerAgeRangeList',
                            comConfig: {
                                allowClear: true,
                                showSearch: true,
                                optionFilterProp: "name",
                                disabled: btnStatus(false),
                                fieldNames: { label: 'name', value: 'key' },
                            }
                        },
                        {
                            name: 'wechatNo',
                            label: '微信',
                            spanCol: 12,
                            comConfig: {
                                disabled: btnStatus(false),
                            },
                        },
                        {
                            name: 'qq',
                            label: 'QQ',
                            spanCol: 12,
                            comConfig: {
                                disabled: btnStatus(false),
                            },
                        },
                        {
                            name: 'email',
                            label: '邮箱',
                            spanCol: 12,
                            comConfig: {
                                disabled: btnStatus(false),
                            },
                        },
                        {
                            name: 'career',
                            label: '职业',
                            spanCol: 12,
                            type: 'select',
                            data: 'customerProfessionList',
                            comConfig: {
                                allowClear: true,
                                showSearch: true,
                                optionFilterProp: "name",
                                disabled: btnStatus(false),
                                fieldNames: { label: 'name', value: 'key' },
                            },
                        }

                    ]
                },
                {
                    title: '房屋信息',
                    formItem: [
                        {
                            name: 'channelId',
                            label: '客户来源',
                            required: true,
                            spanCol: 12,
                            children: <Cascader
                                placeholder="请选择"
                                showSearch
                                expandTrigger="hover"
                                options={sourceChannelList}
                                disabled={getAuth['customerManageBtnChannelId']}
                            />
                        },
                        {
                            name: 'buildingId',
                            label: '楼盘',
                            required: true,
                            spanCol: 12,
                            type: 'select',
                            data: 'buildList',
                            comConfig: {
                                allowClear: true,
                                showSearch: true,
                                optionFilterProp: "name",
                                // disabled: btnStatus(salesFlag()),
                                disabled: btnStatus(salesFlag()) && getAuth['customerManageBtnBuildingId'],
                                fieldNames: { label: 'name', value: 'id' },
                                onChange: (value, option) => {
                                    let giveHouseDate = option?.data?.giveHouseDate;
                                    if (JSON.stringify(giveHouseDate) != 'null') {
                                        formRef.current?.onFormRef()?.setFieldsValue({ ...(giveHouseDate && { giveHouseDate: dayjs(giveHouseDate) }) });
                                    }
                                }
                            },
                        },
                        {
                            name: 'houseNatureCode',
                            label: '房屋属性',
                            required: true,
                            spanCol: 12,
                            type: 'select',
                            data: 'bizOpPropertyTypeList',
                            comConfig: {
                                allowClear: true,
                                showSearch: true,
                                optionFilterProp: "name",
                                disabled: btnStatus(infoObj?.clueStatus == 'DESIGN'),
                                fieldNames: { label: 'name', value: 'key' },
                            },
                        },
                        {
                            name: 'doorNo',
                            label: '门牌号',
                            spanCol: 12,
                            comConfig: {
                                disabled: btnStatus(salesFlag()),
                            },
                        },
                        // 房屋状态为期房时，需要选择交房日期
                        {
                            name: 'houseStatusCode',
                            label: '房屋状态',
                            spanCol: 12,
                            type: 'select',
                            data: 'houseStatusList',
                            comConfig: {
                                allowClear: true,
                                showSearch: true,
                                optionFilterProp: "description",
                                disabled: btnStatus(infoObj?.clueStatus == 'DESIGN'),
                                fieldNames: { label: 'description', value: 'key' },
                                onChange: () => {
                                    if (!giveHouseDate) formRef.current?.onFormRef()?.resetFields(['giveHouseDate']);
                                }
                            },
                        },
                        {
                            name: 'giveHouseDate',
                            label: '交房日期',
                            spanCol: 12,
                            type: 'date',
                            required: formRef.current?.onFormRef()?.getFieldValue('houseStatusCode') === 'FUTURE_HOUSE',
                            comConfig: {
                                allowClear: true,
                                disabled: btnStatus(infoObj?.clueStatus == 'DESIGN'),
                                disabledDate: (current) => {
                                    let today = new Date();
                                    let houseStatusCode = formRef.current?.onFormRef()?.getFieldValue('houseStatusCode');
                                    if (houseStatusCode == 'EXISTING_HOUSE') {
                                        return current >= dayjs(today.setDate(today.getDate()));
                                    } else if (houseStatusCode == 'FUTURE_HOUSE') {
                                        return current <= dayjs(today.setDate(today.getDate()));
                                    } else {
                                        return false;
                                    }
                                },
                            },
                        },
                        {
                            name: 'houseKindCode',
                            label: '房屋类型',
                            spanCol: 12,
                            type: 'select',
                            data: 'housePropertyTypeList',
                            comConfig: {
                                allowClear: true,
                                showSearch: true,
                                optionFilterProp: "name",
                                disabled: btnStatus(false),
                                fieldNames: { label: 'name', value: 'key' },
                            },
                        },
                        {
                            name: 'houseTypeCode',
                            label: '户型',
                            spanCol: 12,
                            type: 'select',
                            data: 'houseTypeList',
                            comConfig: {
                                allowClear: true,
                                showSearch: true,
                                optionFilterProp: "name",
                                disabled: btnStatus(false),
                                fieldNames: { label: 'name', value: 'key' },
                            },
                        },
                        {
                            name: 'constructionArea',
                            label: '建筑面积',
                            spanCol: 12,
                            type: 'inputNumber',
                            comConfig: {
                                style: { width: '100%' },
                                allowClear: true,
                                disabled: btnStatus(false),
                                min: 0,
                                precision: 2,
                            },
                        },
                        {
                            name: 'constructionAreaRange',
                            label: '建筑面积区间',
                            spanCol: 12,
                            type: 'select',
                            data: 'AreaIntervalList',
                            comConfig: {
                                allowClear: true,
                                showSearch: true,
                                optionFilterProp: "name",
                                disabled: btnStatus(false),
                                fieldNames: { label: 'name', value: 'key' },
                            },
                        },
                        {
                            name: 'inHouseSize',
                            label: '套内面积',
                            spanCol: 12,
                            type: 'inputNumber',
                            comConfig: {
                                style: { width: '100%' },
                                allowClear: true,
                                disabled: btnStatus(false),
                                min: 0,
                                precision: 2,
                            },
                        },
                        {
                            name: 'houseHight',
                            label: '层高',
                            spanCol: 12,
                            type: 'inputNumber',
                            comConfig: {
                                style: { width: '100%' },
                                allowClear: true,
                                disabled: btnStatus(false),
                                min: 0,
                                precision: 0,
                            },
                        },
                        // {
                        //     name: 'doorNo',
                        //     label: '楼盘详细地址',
                        //     spanCol: 24,
                        //     comConfig: {
                        //         disabled: btnStatus(salesFlag()),
                        //     },
                        // }
                    ]
                },
                {
                    title: '家空间需求',
                    formItem: [
                        {
                            name: 'budget',
                            label: '装修预算',
                            spanCol: 12,
                            type: 'select',
                            data: 'budgetList',
                            comConfig: {
                                allowClear: true,
                                showSearch: true,
                                optionFilterProp: "name",
                                disabled: btnStatus(false),
                                fieldNames: { label: 'name', value: 'key' },
                            },
                        },
                        {
                            name: 'houseDemand',
                            label: '功能需求',
                            spanCol: 12,
                            type: 'select',
                            data: 'functionNeedList',
                            comConfig: {
                                allowClear: true,
                                showSearch: true,
                                optionFilterProp: "name",
                                disabled: btnStatus(false),
                                fieldNames: { label: 'name', value: 'key' },
                            },
                        },
                        {
                            name: 'designStyleCode',
                            label: '装修风格',
                            spanCol: 12,
                            type: 'select',
                            data: 'houseDecorateStyleList',
                            comConfig: {
                                allowClear: true,
                                showSearch: true,
                                optionFilterProp: "name",
                                disabled: btnStatus(false),
                                fieldNames: { label: 'name', value: 'key' },
                            },
                        },
                        {
                            name: 'expectRenovationDate',
                            label: '预计装修日期',
                            spanCol: 12,
                            type: 'date',
                            comConfig: {
                                allowClear: true,
                                disabled: btnStatus(false),
                            },
                        },
                        {
                            name: 'signIntentionCode',
                            label: '签单意向',
                            spanCol: 12,
                            type: 'select',
                            data: 'signBillIntentList',
                            comConfig: {
                                allowClear: true,
                                showSearch: true,
                                optionFilterProp: "name",
                                disabled: btnStatus(false),
                                fieldNames: { label: 'name', value: 'key' },
                            },
                        },
                        {
                            name: 'painPoint',
                            label: '痛点',
                            spanCol: 12,
                            type: 'select',
                            data: 'PainPointList',
                            comConfig: {
                                allowClear: true,
                                showSearch: true,
                                optionFilterProp: "name",
                                disabled: btnStatus(false),
                                fieldNames: { label: 'name', value: 'key' },
                                mode: "multiple",
                            },
                        },
                        {
                            name: 'painPointRemark',
                            label: '痛点备注',
                            spanCol: 12,
                            isHideItem: !hasRemark('painPoint', 'PainPointOther'),
                            comConfig: {
                                disabled: btnStatus(false),
                            },
                        },
                        {
                            name: 'itchPoint',
                            label: '痒点',
                            spanCol: 12,
                            type: 'select',
                            data: 'ItchyList',
                            comConfig: {
                                allowClear: true,
                                showSearch: true,
                                optionFilterProp: "name",
                                disabled: btnStatus(false),
                                fieldNames: { label: 'name', value: 'key' },
                                mode: "multiple",
                            },
                        },
                        {
                            name: 'itchPointRemark',
                            label: '痒点备注',
                            spanCol: 12,
                            isHideItem: !hasRemark('itchPoint', 'ItchyOther'),
                            comConfig: {
                                disabled: btnStatus(false),
                            },
                        },
                        {
                            name: 'breakPoint',
                            label: '爆破点',
                            spanCol: 12,
                            type: 'select',
                            data: 'BlastingPointList',
                            comConfig: {
                                allowClear: true,
                                showSearch: true,
                                optionFilterProp: "name",
                                disabled: btnStatus(false),
                                fieldNames: { label: 'name', value: 'key' },
                                mode: "multiple",
                            },
                        },
                        {
                            name: 'breakPointRemark',
                            label: '爆破点备注',
                            spanCol: 12,
                            isHideItem: !hasRemark('breakPoint', 'BlastingPointOther'),
                            comConfig: {
                                disabled: btnStatus(false),
                            },
                        },
                        {
                            name: 'blockPoint',
                            label: '障碍点',
                            spanCol: 12,
                            type: 'select',
                            data: 'ObstaclePointList',
                            comConfig: {
                                allowClear: true,
                                showSearch: true,
                                optionFilterProp: "name",
                                disabled: btnStatus(false),
                                fieldNames: { label: 'name', value: 'key' },
                                mode: "multiple",
                            },
                        },
                        {
                            name: 'blockPointRemark',
                            label: '障碍点备注',
                            spanCol: 12,
                            isHideItem: !hasRemark('blockPoint', 'ObstaclePointOther'),
                            comConfig: {
                                disabled: btnStatus(false),
                            },
                        },
                        {
                            name: 'remark',
                            label: '备注',
                            spanCol: 24,
                            type: 'textarea',
                            comConfig: {
                                disabled: btnStatus(false),
                                rows: 2,
                            },
                        }
                    ]
                }
            ]}
        />
    </Spin>
})
type AddOrEditCluePage = {
  open: boolean
  data?: any
  onClose?: (success?: boolean) => void
  fn?: () => void
  isCall?: boolean//是否是呼叫管理页面
}
export const AddOrEditDrawer = (props: AddOrEditCluePage) => {
  const {open, data, onClose, fn, ...rest} = props;
  const addRef = useRef();
  const [loading, setLoading] = useState(true);
  // const [isOpen, setIsOpen] = useState(open);
  useEffect(() => {
    open && setLoading(true);
    return () => {
      setLoading(false);
    }
  }, [])
  return <SDrawer
      getContainer='#root'
      loading={loading}
      open={open}
      onClose={() => {
        onClose && onClose();
      }}
      destroyOnClose={true}
      styles={{body: {padding: '0 15px'}}}
      onSubmit={() => {
        setLoading(true);
        const addRefNode: any = addRef?.current;
        addRefNode?.onFinish().then(() => {
          setLoading(false);
          onClose && onClose()
        }).catch(() => {
          setLoading(false);
        });
      }}
      isHideResetBtn={true}
      // onResetFn={() => {
      //     setLoading(true);
      //     const addRefNode: any = addRef?.current;
      //     addRefNode?.resetFn().finally(()=>{
      //       setLoading(false);
      //     });
      // }}
      title={!!data?.id ? rest.title + '编辑' : '新增'}
  >
    {open && <ModalAddOrEditDom
        ref={addRef}
        record={data}
        fn={() => {
          fn && fn();
          setLoading(false);
        }}
        dataFinishFn={() => {
          setLoading(false);
        }}
        {...rest}
    />}
  </SDrawer>
}
